<template>
  <Row>
    <i-col span="24">
      <h1>Welcome {{ currentUser.name }}</h1>
      <br />
      <MonthlyFiguresDisastersChart />
      <MonthlyFiguresConflictChart />
    </i-col>
  </Row>
</template>

<script>
import MonthlyFiguresDisastersChart from "@/dashboards/analysis/components/MonthlyFiguresDisastersChart.vue";
import MonthlyFiguresConflictChart from "@/dashboards/analysis/components/MonthlyFiguresConflictChart.vue";

export default {
  name: "Home",
  components: {
    MonthlyFiguresDisastersChart,
    MonthlyFiguresConflictChart,
  },
};
</script>

<style lang="css"></style>
